export default __webpack_public_path__ + "static/media/target-audience.24471030.svg";